var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import TctWindowEventContext from '../../context/tct-window-context';
import WindowConfigContext from '../../context/window-config-context';
import { HermesysColors } from './Colors';
import { TCT_PHONELIST } from './Constants';
export var StyledTable = styled.table(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  border-collapse: collapse;\n\n  > thead tr {\n    background: rgba(24, 30, 48, 1);\n  }\n  > tbody .centered {\n    text-align: center;\n  }\n  > thead .centered {\n    text-align: center;\n  }\n  > tbody tr td {\n    border: solid 1px ", ";\n  }\n  > thead tr th {\n    border: solid 1px ", ";\n  }\n  tr[data-disabled='true'] {\n    color: gray;\n  }\n  tbody tr:not([data-disabled='true']) td[data-color='red'] {\n    color: rgba(194, 30, 5, 0.8);\n  }\n  tbody tr:not([data-disabled='true']) td[data-color='yellow'] {\n    color: yellow;\n  }\n"], ["\n  width: 100%;\n  border-collapse: collapse;\n\n  > thead tr {\n    background: rgba(24, 30, 48, 1);\n  }\n  > tbody .centered {\n    text-align: center;\n  }\n  > thead .centered {\n    text-align: center;\n  }\n  > tbody tr td {\n    border: solid 1px ", ";\n  }\n  > thead tr th {\n    border: solid 1px ", ";\n  }\n  tr[data-disabled='true'] {\n    color: gray;\n  }\n  tbody tr:not([data-disabled='true']) td[data-color='red'] {\n    color: rgba(194, 30, 5, 0.8);\n  }\n  tbody tr:not([data-disabled='true']) td[data-color='yellow'] {\n    color: yellow;\n  }\n"])), HermesysColors.main.dimWhite, HermesysColors.main.dimWhite);
export var DialPadButton = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: solid 1px ", ";\n  padding: 10px;\n  color: white;\n  cursor: pointer;\n  border-radius: 2px;\n  width: 30%;\n  text-align: center;\n  ", "\n"], ["\n  border: solid 1px ", ";\n  padding: 10px;\n  color: white;\n  cursor: pointer;\n  border-radius: 2px;\n  width: 30%;\n  text-align: center;\n  ",
    "\n"])), HermesysColors.main.dimWhite, function (_a) {
    var width = _a.width;
    return "\n       width: " + width + ";\n";
});
export var StyledPhoneList = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border: solid 1px ", ";\n  width: 90%;\n"], ["\n  border: solid 1px ", ";\n  width: 90%;\n"])), HermesysColors.main.dimWhite);
var dialPad = [
    { label: '<-', id: 'dial_back' },
    { label: '1', id: 'dial_1' },
    { label: '2', id: 'dial_2' },
    { label: '3', id: 'dial_3' },
    { label: '4', id: 'dial_4' },
    { label: '5', id: 'dial_5' },
    { label: '6', id: 'dial_6' },
    { label: '7', id: 'dial_7' },
    { label: '8', id: 'dial_8' },
    { label: '9', id: 'dial_9' },
    { label: '0', id: 'dial_0' },
    { label: 'CALL', id: 'dial_call', width: '64%' },
    { label: 'PHONE LIST', id: 'dial_phonelist', width: '40%' },
    { label: 'CANCEL', id: 'dial_cancel', width: '40%' },
];
export function PhoneCall(props) {
    var goToMain = props.goToMain, setActive = props.setActive;
    var _a = useState(''), phoneNumber = _a[0], setPhoneNumber = _a[1];
    var config = useContext(WindowConfigContext);
    var _b = useContext(TctWindowEventContext), _onCallButtonClick = _b._onCallButtonClick, _onPhoneButtonClick = _b._onPhoneButtonClick, _onButtonClick = _b._onButtonClick, _onPhoneListClick = _b._onPhoneListClick;
    var onPhonePadClick = function (item) {
        var id = item.id, label = item.label;
        var buttonClick = config.isBuilder ? _onButtonClick : _onPhoneButtonClick;
        if (id === 'dial_back') {
            buttonClick(item.id);
            setPhoneNumber(phoneNumber.slice(0, -1));
        }
        else if (id === 'dial_cancel') {
            buttonClick(item.id);
            goToMain();
        }
        else if (id === 'dial_call') {
            _onCallButtonClick(item.id, phoneNumber);
        }
        else if (id === 'dial_phonelist') {
            setActive(TCT_PHONELIST);
            config.isBuilder ? _onButtonClick(item.id) : _onPhoneListClick(item.id);
        }
        else {
            buttonClick(item.id);
            setPhoneNumber(phoneNumber + label);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { width: '64%' } }, phoneNumber),
        dialPad.map(function (item) {
            var _a;
            return (React.createElement(DialPadButton, { key: item.id, id: item.id, width: (_a = item === null || item === void 0 ? void 0 : item.width) !== null && _a !== void 0 ? _a : '30%', onClick: function () { return onPhonePadClick(item); } }, item.label));
        })));
}
export function PhoneList(props) {
    var config = useContext(WindowConfigContext);
    var _a = useContext(TctWindowEventContext), _onCallListItemSelect = _a._onCallListItemSelect, _onPhoneListButtonClick = _a._onPhoneListButtonClick, _onButtonClick = _a._onButtonClick;
    var onSelect = function (datum, index) {
        _onCallListItemSelect(datum.extension, index, !datum.selected);
    };
    var _b = props.phoneList, phoneList = _b === void 0 ? [] : _b;
    var buttonClick = config.isBuilder
        ? _onButtonClick
        : _onPhoneListButtonClick;
    return (React.createElement(React.Fragment, null,
        React.createElement(DialPadButton, { width: '40%', id: "tct_phone_page_up" }, "Page Up"),
        React.createElement(DialPadButton, { width: '40%', id: "tct_phone_page_down" }, "Page Down"),
        React.createElement(StyledPhoneList, { id: 'tct_phone_list' },
            React.createElement(StyledTable, { id: 'tct_phone_list_table' },
                React.createElement("colgroup", null,
                    React.createElement("col", { style: { width: '10%' } }),
                    React.createElement("col", { style: { width: '90%' } })),
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, "EXT."),
                        React.createElement("th", null, "ROOM"))),
                React.createElement("tbody", null, phoneList.map(function (datum, k) {
                    return (React.createElement("tr", { key: k, id: "ext_" + datum.extension, onClick: function () { return onSelect(datum, k); }, style: {
                            backgroundColor: datum.selected ? 'white' : 'inherit',
                            color: datum.selected ? 'black' : 'inherit',
                        } },
                        React.createElement("td", null, datum.extension),
                        React.createElement("td", null, datum.room)));
                })))),
        React.createElement(DialPadButton, { width: '40%', id: "tct_phone_list_select", onClick: function () { return buttonClick('tct_phone_list_select'); } }, "SELECT"),
        React.createElement(DialPadButton, { width: '40%', id: "tct_phone_list_cancel", onClick: props.goToMain }, "CANCEL")));
}
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=PhoneCall.js.map